import { refreshMenu } from '@/permission'

// 全局单例，整个iframe页面只绑定一次window message
const globalMessageBus = {
  handler: null,
  activeVm: null,
  init() {
    if (this.handler) return;
    this.handler = async (event) => {
      if (!this.activeVm) return;
      await this.activeVm._globalMessageHandler(event);
    }
    window.addEventListener('message', this.handler);
  },
  destroy() {
    if (this.handler) {
      window.removeEventListener('message', this.handler);
      this.handler = null;
    }
  }
}

export const iframeMonitorMixin = {
  data() {
    return {
      _clickHighlightEl: null,
      _configBtnEl: null,
      _updateTimer: null,
      _handleClickOutside: null,
      _handleGetRect: null,
      _clickLabelEl: null,
      _isRefreshingMenu: false,
    }
  },
  methods: {
    // 供全局bus调用的消息处理
    async _globalMessageHandler(event) {
      const { type, monitorId } = event.data || {};
      if (type === 'HIGHLIGHT_ELEMENT' && monitorId) {
        this.clearAllHighlights();
        const targetEl = document.querySelector(`[data-monitor="${monitorId}"]`);
        if (targetEl) {
          targetEl.classList.add('dottedLine');
          this.createConfigBtn(targetEl);
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else if (type === 'GET_ELEMENT_RECT' && monitorId) {
        const el = document.querySelector(`[data-monitor="${monitorId}"]`);
        if (el) {
          this.showClickHighlight(el);
        }
      } else if (type === 'UPDATE_MENUS' && monitorId) {
        if (this._isRefreshingMenu) {
          console.log("菜单刷新中，忽略本次消息");
          return;
        }
        console.log("父容器更新菜单......")
        this._isRefreshingMenu = true;
        try {
          await refreshMenu()
        } finally {
          this._isRefreshingMenu = false;
        }
      }
    },
    clearAllHighlights() {
      document.querySelectorAll('.dottedLine').forEach(item => item.classList.remove('dottedLine'));
      this.destoryConfigBtn();
      this.hideClickHighlight();
    },
    destoryConfigBtn() {
      if (this._configBtnEl) {
        this._configBtnEl.remove();
        this._configBtnEl = null;
      }
    },
    createConfigBtn(targetEl) {
      if (!targetEl) return;
      this.destoryConfigBtn();
      if (getComputedStyle(targetEl).position === 'static') {
        targetEl.style.position = 'relative';
      }
      const oldBtn = targetEl.querySelector('[data-config-btn]');
      if (oldBtn) oldBtn.remove();
      const configBtn = document.createElement('div');
      configBtn.setAttribute('data-config-btn', 'true');
      configBtn.innerHTML = `
        <i class="el-icon-setting"></i>
        <span style="margin-left:4px;font-size:12px;">${targetEl.getAttribute('data-monitor')}</span>
      `;
      configBtn.style.cssText = `
        position: absolute;
        right: -12px;
        top: -12px;
        height: 30px;
        padding: 0 10px;
        background: #409eff;
        border-radius: 15px;
        cursor: pointer;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #fff;
        white-space: nowrap;
      `;
      configBtn.onclick = (e) => {
        e.stopPropagation();
        const monitorId = targetEl.getAttribute('data-monitor');
        window.parent.postMessage({
          type: 'OPEN_ELEMENT_CONFIG',
          monitorId
        }, '*')
      };
      targetEl.appendChild(configBtn);
      this._configBtnEl = configBtn;
    },

    initIframeMonitor() {
      // 1. 清空高亮按钮
      document.querySelectorAll('[data-config-btn]').forEach(btn => btn.remove());
      document.querySelectorAll('.dottedLine').forEach(item => item.classList.remove('dottedLine'));
      this.destoryConfigBtn();
      this.hideClickHighlight();

      // 2. 点击外部关闭
      if (this._handleClickOutside) {
        document.removeEventListener('click', this._handleClickOutside);
      }
      const handleClickOutside = (e) => {
        if (!e.target.closest('[data-monitor]') && !e.target.closest('[data-config-btn]')) {
          this.clearAllHighlights();
        }
      };
      document.addEventListener('click', handleClickOutside);
      this._handleClickOutside = handleClickOutside;

      // 把当前实例设置为全局激活实例
      globalMessageBus.activeVm = this;
      globalMessageBus.init();
    },

    hideClickHighlight() {
      if (this._clickHighlightEl) {
        this._clickHighlightEl.remove();
        this._clickHighlightEl = null;
      }
      if (this._clickLabelEl) {
        this._clickLabelEl.remove();
        this._clickLabelEl = null;
      }
    },
    sendMenuClickToParent(menuPath, menuName = '') {
      if (!menuPath) return
      if (this._lastMenuPath === menuPath) return
      this._lastMenuPath = menuPath
      if (window.parent !== window) {
        window.parent.postMessage({
          type: 'MENU_CLICK',
          menuPath: menuPath,
          menuName: menuName
        }, '*')
      }
    },
    refreshIframeMonitor() {
      this.initIframeMonitor()
    },
    showClickHighlight(el) {
      this.hideClickHighlight();
      document.querySelectorAll('.dottedLine').forEach(item => {
        item.classList.remove('dottedLine');
      });
      this.destoryConfigBtn();
      const h = document.createElement('div');
      h.style.cssText = `
        position: absolute;
        z-index: 99;
        pointer-events: none;
        border: 2px dashed #409eff; 
        border-radius: 4px;
        box-sizing: border-box;
        transition: all 0.2s ease;
      `;
      const rect = el.getBoundingClientRect();
      h.style.left = rect.left + window.scrollX + 'px';
      h.style.top = rect.top + window.scrollY + 'px';
      h.style.width = rect.width + 'px';
      h.style.height = rect.height + 'px';
      document.body.appendChild(h);
      this._clickHighlightEl = h;
      const label = document.createElement('div');
      label.style.cssText = `
        position: absolute;
        z-index: 100;
        background: #409eff;
        color: #fff;
        font-size: 12px;
        padding: 4px 10px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        gap: 4px;
        white-space: nowrap;
        cursor: pointer;
      `;
      label.innerHTML = `
        <i class="el-icon-setting"></i>
        <span style="margin-left:4px;font-size:12px;">${el.getAttribute('data-monitor')}</span>
      `;
      label.onclick = (e) => {
        e.stopPropagation();
        const monitorId = el.getAttribute('data-monitor');
        if (window.parent !== window) {
          window.parent.postMessage({
            type: 'OPEN_ELEMENT_CONFIG',
            monitorId: monitorId
          }, '*');
        }
      };
      label.style.left = rect.right - 10 + 'px';
      label.style.top = rect.top - 18 + 'px';
      
      document.body.appendChild(label);
      this._clickLabelEl = label;
    }
  },
  mounted() {
    console.log('查看mounted======')
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIframeMonitor()
      }, 100)
    })
  },
  beforeDestroy() {
    clearTimeout(this._updateTimer);
    this.hideClickHighlight()
    this.destoryConfigBtn()
    if (this._handleClickOutside) {
      document.removeEventListener('click', this._handleClickOutside);
    }
    // 如果当前销毁的实例是全局激活实例，清空
    if(globalMessageBus.activeVm === this){
      globalMessageBus.activeVm = null;
    }
    this._isRefreshingMenu = false
  }
}
